var _path, _path2, _path3, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSucaiSelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0003 1.5L1.40618 6.79708L12.0003 12.0942L22.5945 6.79708L12.0003 1.5Z",
    fill: "url(#paint0_linear)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1681 14.3835L21.353 15.5164L22.8511 16.2932L21.353 17.07L12.4023 21.7111L11.9995 21.92L11.5967 21.7111L2.64601 17.07L1.14792 16.2932L2.64601 15.5164L4.83228 14.3828L6.7677 15.3505L4.94965 16.2932L11.9995 19.9487L19.0493 16.2932L17.2327 15.3513L19.1681 14.3835Z",
    fill: "#0057FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1523 9.50708L21.3532 10.6483L22.8513 11.4251L21.3532 12.2019L12.4025 16.843L11.9997 17.0518L11.597 16.843L2.64625 12.2019L1.14817 11.4251L2.64625 10.6483L4.84837 9.50647L6.78379 10.4742L4.94989 11.4251L11.9997 15.0806L19.0496 11.4251L17.2169 10.4748L19.1523 9.50708Z",
    fill: "#0057FF"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: 7.18849,
    y1: 3.10378,
    x2: 23.7609,
    y2: 14.8648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0057FF",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0057FF",
    stopOpacity: 0.02
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSucaiSelected);
export default __webpack_public_path__ + "static/media/sucai-selected.4c77306f7705528cb5265997d65f0069.svg";
export { ForwardRef as ReactComponent };